import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { DASHBOARD_TYPE_ENUM, MONTH_ENUM } from "../../../core/dictionary/global";
import trackingEventDictionary from "../../../core/dictionary/tracking-event";
import { getApiUrl } from "../../../utils/baseUrl";
import styles from "../../../containers/shipments/components/RightPanel/components/ReloadSearch/reloadSearch.module.scss";
import { useSelector } from "react-redux";
import { globalCountryDetailsDictionary } from "@core/global/global-country-details";
import { captureException } from "@sentry/react";
import { BRAND } from "@core/brand/brand-config";
const intelHeader = {
  notification_center: getApiUrl("notification_center/close_notifications"),
};
const TABS = {
  request: "Requests",
  savedSearch: "Saved Searches",
};

const NotificationModal = ({ setNotification, getDataHandler, data, saveSearchNotification, callingTrackingEvents, showOnboardingButton }) => {
  const [modalData, setModalData] = useState([]);
  const [saveSearchData, setSaveSearchData] = useState([]);
  const [currentTab, setCurrentTab] = useState(TABS.request);
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const STARTERPLAN = creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("starter"))?.navigate === "search";

  useEffect(() => {
    if (data.length) {
      setModalData(data.slice(0, 3));
    }
    if (saveSearchNotification.length) {
      const sharedSearches = saveSearchNotification.filter((item) => item.source === "sharedSaveSearch");
      setSaveSearchData(sharedSearches.slice(0, 3));
    }
  }, [data, saveSearchNotification]);

  const datasourceParams = React.useMemo(() => {
    const match = Object.values(globalCountryDetailsDictionary).find((item) => window.location.href.includes(item.countryPathName));
    if (!match) {
      const urlParams = new URLSearchParams(window.location.search);
      const country = urlParams.get("country");
      const dataSource = urlParams.get("type");
      return country ? `?country=${country}&type=${dataSource}` : `?country=multicountry&type=import`;
    }
    return `?${match.countryUrlDashboard}&type=${match.countryType}`;
  }, []);

  const getDatasourceURL = React.useCallback(
    (path) => {
      return `${window.location.origin}${path}${datasourceParams}`;
    },
    [datasourceParams]
  );

  const redirectToShipments = () => {
    window.location.href = BRAND.key === "source_atlas" ? `${window.location.origin}/global-search` : `${window.location.origin}/all-country-shipments`;
  };

  const loadMorehandler = (tabType) => {
    callingTrackingEvents(trackingEventDictionary.headerNotificationCentreLoadMore);
    if (tabType === TABS.request) {
      const currentLength = modalData.length;
      const remainingItems = data.slice(currentLength);
      const itemsToAdd = remainingItems.slice(0, 3);
      setModalData([...modalData, ...itemsToAdd]);
    } else if (tabType === TABS.savedSearch) {
      const sharedSearches = saveSearchNotification.filter((item) => item.source === "sharedSaveSearch");
      const currentLength = saveSearchData.length;
      const remainingItems = sharedSearches.slice(currentLength);
      const itemsToAdd = remainingItems.slice(0, 3);
      setSaveSearchData([...saveSearchData, ...itemsToAdd]);
    }
  };

  const markAllAsRead = () => {
    let filter = data.filter((item) => !item.isViewed);
    let filterSavedSearch = saveSearchNotification.filter((item) => item.source === "sharedSaveSearch").filter((item) => !item.isViewed);
    axios
      .post(intelHeader.notification_center, {
        request_id: [...filter, ...filterSavedSearch].map((item) => item.requestId),
      })
      .then(() => {
        setTimeout(() => {
          getDataHandler();
        }, 200);
      })
      .catch((error) => {
        toast.error("Something went wrong");
        captureException(error);
      });
  };

  const selectDataHandler = (item) => {
    axios
      .post(intelHeader.notification_center, {
        request_id: [item.requestId],
      })
      .then(() => {
        setTimeout(() => {
          getDataHandler();
          const baseUrl = getDatasourceURL("/dashboard/request-centre") + `&currenttab=${DASHBOARD_TYPE_ENUM[1].name}&requestId=${item.requestId}`;
          const activeIndex = item.source === "contacts" ? "0" : item.source === "downloads" ? "2" : item.source === "due_diligence" ? "3" : "1";
          window.location.href = `${baseUrl}&activeIndex=${activeIndex}`;
        }, 100);
      })
      .catch((error) => {
        toast.error("Something went wrong");
        captureException(error);
      });
  };

  const selectSaveSearchHandler = async (item) => {
    try {
      await axios.post(intelHeader.notification_center, { request_id: [item.requestId] });
      await getDataHandler();
      redirectToShipments();
    } catch (error) {
      toast.error("Something went wrong");
      captureException(error);
    }
  };

  const setHeadingHandler = (item) => {
    if (item.source === "contacts") {
      return (
        <span className="new_notification_description">
          {" "}
          {item.requestType === "single" ? "Single" : "Bulk"} contact request<span className="notification_hightlighted_text"> {item.requestId}</span> has been {item.status === "closed - Contacts Not Found" ? "" : "successfully"} closed{" "}
        </span>
      );
    } else if (item.source === "downloads") {
      return (
        <span className="new_notification_description">
          Download request<span className="notification_hightlighted_text"> {item.requestId}</span> has been delivered
        </span>
      );
    } else if (item.source === "due_diligence") {
      return (
        <span className="new_notification_description">
          Due Dilligence Report request for <span className="notification_hightlighted_text"> {item.requestId}</span> has been delivered
        </span>
      );
    } else {
      return (
        <span className="new_notification_description">
          {item.alertType === "company" ? (
            <span>
              Company Email alert <span className="notification_hightlighted_text"> {item.requestId}</span> has been delivered
            </span>
          ) : item.source === "sharedSaveSearch" ? (
            <span>
              <span className="notification_hightlighted_text">{item.sender_name}</span> has shared the saved search <span className="notification_hightlighted_text">{item.search_name}</span> with you.
            </span>
          ) : (
            <span>
              Intelligent email alert <span className="notification_hightlighted_text"> {item.requestId}</span> for saved search has been delivered
            </span>
          )}
        </span>
      );
    }
  };
  return (
    <div onClick={(e) => e.stopPropagation()} className={`position-absolute notification-modal ${showOnboardingButton ? "tw-right-[400px]" : "tw-right-[245px]"}`}>
      <Modal.Header className="py-1 notification-header d-flex align-items-center justify-content-between">
        <h5 className="m-0">Notification Center</h5>
        {modalData.length || saveSearchData.length ? (
          <p onClick={() => markAllAsRead()} className="m-0">
            Mark All as read
          </p>
        ) : (
          <></>
        )}
      </Modal.Header>
      <div className={`${styles.nav_container} pt-2 px-2`}>
        <div className={`${styles.nav_item} pl-2 ${currentTab === TABS.request && styles.active}`} onClick={() => setCurrentTab(TABS.request)}>
          Request
        </div>
        {!STARTERPLAN && (
          <div className={`${styles.nav_item} ${currentTab === TABS.savedSearch && styles.active}`} onClick={() => setCurrentTab(TABS.savedSearch)}>
            Shared Searches
          </div>
        )}
      </div>
      <Modal.Body className="py-1 notification_modal">
        {currentTab === TABS.request ? (
          <>
            {!!modalData && !!modalData.length ? (
              modalData.map((item) => (
                <div onClick={() => selectDataHandler(item)} className="notification py-2" key={item.requestId}>
                  <p className="d-flex align-items-center mb-0">
                    {item.isViewed ? <span className="read_notifation_icon mr-1"></span> : <span className="new_notification_icon mr-1"></span>}
                    {setHeadingHandler(item)}
                  </p>
                  {item.responseDate && <p className="new_notification_date mb-0 pb-2">{`${MONTH_ENUM[new Date(item.responseDate).getMonth()]} ${new Date(item.responseDate).getDate()}, ${new Date(item.responseDate).getFullYear()}`}</p>}
                </div>
              ))
            ) : (
              <div className="tw-flex tw-flex-col tw-gap-3 tw-py-4 tw-justify-center tw-items-center tw-text-center">
                <img width={50} height={50} src="https://res.cloudinary.com/drzta9shk/image/upload/v1684488643/intel/icons/notifications_off_vqdw46.svg" alt="No notifications" />
                <p>Updates on your raised requests will appear here. Currently, no notifications are available.</p>
                <div className="d-flex align-items-center justify-content-center">
                  <button
                    onClick={() => {
                      callingTrackingEvents(trackingEventDictionary.headerNotificationCentreClose);
                      setNotification(false);
                    }}
                    className="notification_close_button mr-2">
                    Close
                  </button>
                  <button
                    onClick={() => {
                      callingTrackingEvents(trackingEventDictionary.headerNotificationCentreVisitRequestCentre);
                      window.location.href = `${getDatasourceURL("/dashboard/request-centre")}&currenttab=${DASHBOARD_TYPE_ENUM[1].name}`;
                    }}
                    className="btn btn-primary btn-sm trademo-new-btn">
                    Visit Request Center
                  </button>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            {!!saveSearchData && !!saveSearchData.length ? (
              saveSearchData.map((item) => (
                <div onClick={() => selectSaveSearchHandler(item)} className="notification py-2" key={item.requestId}>
                  <p className="d-flex align-items-center mb-0">
                    {item.isViewed ? <span className="read_notifation_icon mr-1"></span> : <span className="new_notification_icon mr-1"></span>}
                    {setHeadingHandler(item)}
                  </p>
                  {item.responseDate && <p className="new_notification_date mb-0 pb-2">{`${MONTH_ENUM[new Date(item.responseDate).getMonth()]} ${new Date(item.responseDate).getDate()}, ${new Date(item.responseDate).getFullYear()}`}</p>}
                </div>
              ))
            ) : (
              <div className="tw-flex tw-flex-col tw-gap-3 tw-py-4 tw-justify-center tw-items-center tw-text-center">
                <img width={50} height={50} src="https://res.cloudinary.com/drzta9shk/image/upload/v1684488643/intel/icons/notifications_off_vqdw46.svg" alt="No notifications" />
                <p>Searches shared with you by your team will appear here.</p>
                <div className="d-flex align-items-center justify-content-center">
                  <button
                    onClick={() => {
                      callingTrackingEvents(trackingEventDictionary.headerNotificationCentreClose);
                      setNotification(false);
                    }}
                    className="notification_close_button mr-2">
                    Close
                  </button>
                  <button
                    onClick={() => {
                      callingTrackingEvents(trackingEventDictionary.headerNotificationCentreVisitSavedSearches);
                      redirectToShipments();
                    }}
                    className="btn btn-primary btn-sm trademo-new-btn">
                    Visit Saved Searches
                  </button>
                </div>
              </div>
            )}
          </>
        )}
        {((currentTab === TABS.request && modalData.length < data.length) || (currentTab === TABS.savedSearch && saveSearchData.length < saveSearchNotification.filter((item) => item.source === "sharedSaveSearch").length)) && (
          <div className="load_more_notification">
            <p className="m-0" onClick={() => loadMorehandler(currentTab)}>
              Load More <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684489954/intel/icons/refresh_sxvlqk.svg" />
            </p>
          </div>
        )}
      </Modal.Body>
      {modalData.length && currentTab === TABS.request ? (
        <Modal.Footer className="py-1 justify-content-start">
          <button
            onClick={() => {
              callingTrackingEvents(trackingEventDictionary.headerNotificationCentreCheckAllRequests);
              window.location.href = `${getDatasourceURL("/dashboard/request-centre")}&currenttab=${DASHBOARD_TYPE_ENUM[1].name}`;
            }}
            className="btn btn-primary btn-sm trademo-new-btn text-left">
            Check All Requests
          </button>
        </Modal.Footer>
      ) : (
        <></>
      )}
    </div>
  );
};

export default NotificationModal;
